/** Fixed layouts the Team Live multiview switches between (issue #446). */
export type TeamLiveGridMode = 1 | 4 | 9;

/**
 * Hard cap on simultaneous tiles: the largest mode is 3x3, so streaming
 * entries beyond this are not rendered. Documented in
 * docs/superpowers/specs/2026-08-15-team-live-auto-resize-design.md;
 * extending past nine is deferred until tested with more devices.
 */
export const TEAM_LIVE_MAX_TILES = 9;

/**
 * Streaming count -> multiview mode: 1 stream fills the whole view, 2-4 use
 * a 2x2 grid, 5+ use 3x3 (capped by TEAM_LIVE_MAX_TILES elsewhere).
 */
export function getTeamLiveGridMode(streamingCount: number): TeamLiveGridMode {
  if (streamingCount <= 1) return 1;
  if (streamingCount <= 4) return 4;
  return 9;
}

/** Mobile stack column count: 1 in portrait, 2 in landscape. */
export type TeamLiveMobileColumns = 1 | 2;

/**
 * Mobile stack layout columns (2026-09-25 mobile tile layout spec): portrait
 * phones scroll one full-width column; landscape phones get two so tiles
 * stay readable in both orientations.
 */
export function getTeamLiveMobileColumns(
  orientation: "portrait" | "landscape",
): TeamLiveMobileColumns {
  return orientation === "landscape" ? 2 : 1;
}
